
import { Label } from "@/components/ui/label";
import { CardColorSelector } from "./CardColorSelector";
import { CardPerspectiveToggle } from "./CardPerspectiveToggle";

interface CardAppearanceSettingsProps {
  color: string;
  perspective: boolean;
  onColorChange: (value: string) => void;
  onPerspectiveChange: (checked: boolean) => void;
}

export const CardAppearanceSettings = ({ 
  color, 
  perspective, 
  onColorChange, 
  onPerspectiveChange 
}: CardAppearanceSettingsProps) => {
  return (
    <div className="grid gap-2 mt-2">
      <Label>Aparência do Card</Label>
      <div className="grid grid-cols-2 gap-6">
        <CardColorSelector selectedColor={color} onChange={onColorChange} />
        <CardPerspectiveToggle enabled={perspective} onChange={onPerspectiveChange} />
      </div>
    </div>
  );
};
